import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/director.css";

const Director = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "director");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Director | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="director" />
				<div className="content-wrapper">
					<div className="director-logo-container">
						<div className="director-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="director-container">
						<div className="title director-title">
							Things I’ve made trying to put my dent in the
							universe.
						</div>


						<div className="director-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Director;
